import { render, staticRenderFns } from "./MemberViewUserInfoCard.vue?vue&type=template&id=39293926&"
import script from "./MemberViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./MemberViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports